import * as React from 'react'

const SvgLiteratureIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3781_92152)">
      <path
        d="M18.7921 8.6819C20.4027 7.07128 20.4027 4.45061 18.7921 2.84003C18.1073 2.1553 17.2246 1.74065 16.273 1.64936C15.9332 1.04405 15.2872 0.651276 14.5666 0.651276H1.95672C0.877773 0.651276 0 1.52905 0 2.60799C0 3.68694 0.877773 4.56471 1.95672 4.56471H2.60895V17.392C2.60895 18.471 3.48672 19.3487 4.56566 19.3487H17.1756V18.0442C16.8159 18.0442 16.5234 17.7517 16.5234 17.392V10.9507L18.7921 8.6819ZM2.60895 3.26022H1.95672C1.59707 3.26022 1.30449 2.96768 1.30449 2.60799C1.30449 2.24831 1.59707 1.95577 1.95672 1.95577C2.31637 1.95577 2.60895 2.24835 2.60895 2.60799V3.26022ZM4.56566 18.0442C4.20602 18.0442 3.91344 17.7517 3.91344 17.392V2.60799C3.91344 2.37932 3.87367 2.15991 3.80125 1.95577H14.2587C13.7759 2.16046 13.3321 2.45811 12.9502 2.8401L6.3023 9.48788V14.4074L4.64855 16.0611L5.57094 16.9835L7.22469 15.3298H12.1442L15.2189 12.2551V17.392C15.2189 17.6206 15.2583 17.8401 15.3306 18.0442H4.56566V18.0442ZM11.6038 14.0253H8.52914L9.99184 12.5626L12.1814 12.5626L12.1814 11.2581H11.2963L12.7591 9.79538H14.9486V8.49092H14.0636L16.3323 6.22221L15.4099 5.29983L7.60676 13.1029V10.0282L13.8725 3.76249C14.4064 3.2287 15.1161 2.93467 15.8711 2.93467C16.6261 2.93467 17.3358 3.2287 17.8696 3.76249C18.9717 4.8644 18.9717 6.65756 17.8696 7.75952L11.6038 14.0253Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3781_92152">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgLiteratureIcon
